import { useEffect, useState } from 'react';
import AppNav from './components/AppNav.jsx';
import Dashboard from './components/Dashboard.jsx';
import DraftTool from './components/DraftTool.jsx';
import { useAppView } from './hooks/useAppView.js';
import { saveYahooToken } from './services/leagueStorage.js';
import { isYahooCallback, handleYahooCallback } from './services/yahooAuth.js';

/**
 * App shell: Matchups (home), Decide, Draft — setup lives in gear on week views.
 */
const App = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const isCallback = isYahooCallback(searchParams);
  const { view, setView } = useAppView('matchups');

  const [yahooCallbackState, setYahooCallbackState] = useState(
    isCallback ? 'pending' : 'idle',
  );
  const [yahooCallbackError, setYahooCallbackError] = useState('');

  useEffect(() => {
    if (!isCallback) return;

    handleYahooCallback(searchParams)
      .then((tokenData) => {
        saveYahooToken(tokenData);
        setYahooCallbackState('done');
        window.history.replaceState({}, '', window.location.pathname);
      })
      .catch((err) => {
        setYahooCallbackState('error');
        setYahooCallbackError(err.message);
        window.history.replaceState({}, '', window.location.pathname);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (yahooCallbackState === 'pending') {
    return (
      <main className="app-loading" aria-live="polite">
        <span className="dashboard-results__spinner" aria-hidden="true" />
        <p>Connecting your Yahoo account…</p>
      </main>
    );
  }

  if (yahooCallbackState === 'error') {
    return (
      <main className="app-loading">
        <p className="dashboard-form__error" role="alert">
          Yahoo connection failed: {yahooCallbackError}
        </p>
        <button
          className="onboarding-btn onboarding-btn--primary"
          style={{ marginTop: '1rem' }}
          onClick={() => setYahooCallbackState('idle')}
        >
          Back to app
        </button>
      </main>
    );
  }

  const dashboardMode = view === 'decide' ? 'decide' : 'matchups';

  return (
    <div className="app-shell">
      <AppNav activeView={view} onNavigate={setView} />

      <main className="app-main" id="main-content">
        {(view === 'matchups' || view === 'decide') && <Dashboard mode={dashboardMode} />}
        {view === 'draft' && (
          <section className="dashboard dashboard--draft-tab" aria-label="Draft">
            <DraftTool />
          </section>
        )}
      </main>
    </div>
  );
};

export default App;
